"use client"
import { Link, useNavigate } from "react-router-dom"
import { logout } from "../../api/auth"

export function Sidebar() {
  const navigate = useNavigate()

  const handleLogout = (e) => {
    e.preventDefault()
    logout() // Clear token from localStorage
    navigate("/admin/login", { replace: true })
  }

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner slimscroll">
        <div id="sidebar-menu" className="sidebar-menu">
          <ul className="sidebar-vertical">
            <li>
              <Link to="/admin/company-list">
                <i className="fa fa-building"></i> <span> Companies</span>
              </Link>
            </li>

            <li>
              <Link to="/admin/support">
                <i className="fa fa-life-ring"></i> <span> Support</span>
              </Link>
            </li>

            <li>
              <Link to="#" onClick={handleLogout}>
                <i className="fe fe-power"></i> <span>Logout</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
